import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { create as createConfetti } from 'canvas-confetti';

import { BAD_MATCH_REASONS } from '@shared/feedback/button/bad-match-reasons';
import { FeedbackMenuType, FeedbackTag } from '@shared/feedback/menu-content/feedback-menu.data';
import { Feedback, FeedbackType, ThumbValue } from '@shared/models';

@Component({
  selector: 'mojo-feedback-button',
  templateUrl: './feedback-button.component.html',
  styleUrls: ['./feedback-button.component.scss'],
})
export class FeedbackButtonComponent implements OnInit {
  private readonly maxConfettiScreenPosition = 0.9;
  @Input() feedbackModel: Feedback;
  @Input() thumbValue: ThumbValue;
  @Input() selected = true;
  @Input() runConfetti = false;
  @Input() buttonClass = 'btn-medium';
  @Output() thumbSent: EventEmitter<Feedback> = new EventEmitter<Feedback>();
  @Output() thumbWithReasonsSent: EventEmitter<Feedback[]> = new EventEmitter<Feedback[]>();
  @Output() isMenuOpened: EventEmitter<boolean> = new EventEmitter<boolean>();

  BAD_MATCH_REASONS: FeedbackTag[] = BAD_MATCH_REASONS;
  BAD_MATCH_REASON_TYPE = FeedbackType.BAD_MATCH_REASON;
  TAGS_MENU = FeedbackMenuType.TAGS;
  THUMB_DOWN = ThumbValue.DOWN;
  isThumbUp: boolean;
  isThumbDown: boolean;
  previousEventX: number;
  previousEventY: number;
  @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger;

  ngOnInit(): void {
    this.isThumbUp = ThumbValue.UP === this.thumbValue;
    this.isThumbDown = ThumbValue.DOWN === this.thumbValue;
  }

  onThumbClicked(event) {
    if (this.isThumbUp && !this.selected) {
      this.onThumbUpClicked(event);
    }
    if (this.isThumbDown && !this.selected) {
      this.onThumbDownClicked(event);
    }
  }

  onThumbUpClicked(event) {
    event.stopPropagation();
    if (!this.selected) {
      if (this.runConfetti) {
        this.shootConfetti(event.pageX, event.pageY);
      }
      this.thumbSent.emit({
        ...this.feedbackModel,
        value: this.thumbValue,
      });
    }
  }

  onThumbDownClicked(event) {
    event.stopPropagation();
    this.previousEventX = event.pageX;
    this.previousEventY = event.pageY;
    this.menuTrigger.openMenu();
  }

  onFeedbackSent(feedbacks: Feedback[]) {
    this.menuTrigger.closeMenu();
    feedbacks.push({
      ...this.feedbackModel,
      value: this.thumbValue,
    });
    this.thumbWithReasonsSent.emit(feedbacks);
  }

  private shootConfetti(positionX, positionY): void {
    const feedbackConfetti = createConfetti(document.getElementById('confettiCanvas'), {
      resize: true,
      useWorker: true,
    });
    const y = Math.min(positionY / screen.height + 0.05, this.maxConfettiScreenPosition);
    const x = Math.min(positionX / screen.width, this.maxConfettiScreenPosition);
    feedbackConfetti({
      angle: this.randomInRange(55, 125),
      spread: this.randomInRange(50, 70),
      particleCount: this.randomInRange(50, 100),
      origin: {
        y,
        x,
      },
    });
  }

  private randomInRange(min, max): number {
    return Math.random() * (max - min) + min;
  }
}
